export default __webpack_public_path__ + "static/media/Rune Stone of the Styx.d97e0768.jpg";